import React from 'react';
import PublicLayout from '../components/public/PublicLayout';

const Pricing = () => {
  return (
    <PublicLayout>
      <h1>All Features</h1>
      <p>Detailed feature list coming soon...</p>
    </PublicLayout>
  );
};
export default Pricing;